// Vue filter
import {
  maskmobile,
  maskemail
} from './utils.js'
import {
  isNil,
  isEmpty,
  isInteger
} from 'lodash'

export default {
  install (Vue, options) {
    // 手机号添加*
    Vue.filter('maskmobile', (mobile) => {
      return maskmobile(mobile)
    })
    // 邮箱添加*
    Vue.filter('maskemail', (value) => {
      return maskemail(value)
    })
    //
    Vue.filter('none', (val, placeholder = '-') => {
      return isNil(val) || isEmpty(val) ? placeholder : val
    })
    // 保留一位小数点
    Vue.filter('fixedOne', (val) => {
      let newVal = val
      if (!isInteger(Math.abs(val))) {
        newVal = Number(val).toFixed(2)
        // newVal = a.substring(0, a.length - 1)
      }
      return newVal
    })
  }
}



// WEBPACK FOOTER //
// ./src/common/filter.js